import { MicrophoneSlash } from 'iconsax-reactjs';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch } from 'react-redux';
import { selectRoomParticipantInfo, selectRoomPinned, selectRoomTotalParticipants } from '@/store/features/room/selectors';
import { toggleRoomPinned } from '@/store/features/room/slice';
import { useAppSelector } from '@/store/hooks';
import { StyledAvatar, StyledContent, StyledMediaStatus, StyledPin, StyledUserInfo } from './styled';

type Props = {
  sid: string;
  isScreenSharing: boolean;
};

const RemoteParticipantContent: FC<Props> = ({ sid, isScreenSharing }) => {
  const {t} = useTranslation();

  const dispatch = useDispatch();

  const participantInfo = useAppSelector(
    selectRoomParticipantInfo(sid),
    shallowEqual,
  );

  const total = useAppSelector(
    selectRoomTotalParticipants,
  );

  const pinned = useAppSelector(
    selectRoomPinned,
  );

  const onTogglePin = () => {
    dispatch(toggleRoomPinned(sid));
  };

  return (
    <StyledContent
      $transparent={participantInfo.isVideoEnabled}
    >
      {!isScreenSharing && (
        <>
          {!participantInfo.isVideoEnabled && (
            <StyledAvatar name={participantInfo.user?.avatar} />
          )}
          {!participantInfo.isAudioEnabled && (
            <StyledMediaStatus>
              <MicrophoneSlash size={28} color="var(--color-white)" />
            </StyledMediaStatus>
          )}
          <StyledUserInfo>
            <p>{participantInfo.user?.name || ''}</p>
          </StyledUserInfo>
        </>
      )}
      {total > 1 && (
        <StyledPin onClick={onTogglePin}>
          {pinned === sid ? (
            <>
              <img src="/images/unpin.svg" />
              {t('unpin_screen')}
            </>
          ) : (
            <>
              <img src="/images/pin.svg" />
              {t('pin_to_screen')}
            </>
          )}
        </StyledPin>
      )}
    </StyledContent>
  );
};

export default RemoteParticipantContent;
